import '../../../../../../../assets/css/bookings.css';
import '../../../../../../../assets/css/filter.css';
import '../../../../../../../assets/css/tables.css';
import {useState} from 'react';
import * as common from '../../../../../common/__redux/commonRedux';
import {useDictionary} from '../../../../../../../utilities/hooks/UseDictionary';
import {useParams} from "react-router-dom";
import {connect} from "react-redux";
import {updateExperience} from "../../networking";
import ConverterHelper from "../../../../../../../utilities/helpers/Converters";
import 'react-toastify/dist/ReactToastify.css';
import CustomCheckbox from "../../../../../common/CustomCheckbox";
import ReactJson from 'react-json-view';
import {showToast} from "../../../../../../../utilities/helpers/ToastHelper";

const ProviderExperienceEditForm = ({formData: initialFormData, onSubmitClicked: onSubmitClicked}) => {
    const dictionary = useDictionary();
    const {id} = useParams();

    const [formData, setFormData] = useState(initialFormData || {
        title: '',
        description: '',
    });

    const statusOptions = [
        {value: 1, label: "Available"},
        {value: 2, label: "In Progress"},
        {value: 3, label: "Unavailable"},
        {value: 4, label: "Paused"},
        {value: 5, label: "Add Availability"},
        {value: 6, label: "Reselling Disabled"}
    ];

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value ?? "",
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Update data logic here
            await updateExperience(id, formData)
            showToast({
                type: 'success',
                message: dictionary.experience_update_success,
            });
            onSubmitClicked();
        } catch (error) {
            showToast({
                type: 'error',
                message: (error.response?.data?.message) ?? dictionary.experience_update_error,
                position: 'top-right',
                className: 'toast-white-error'
            });
            console.error('Error updating experience:', error);
        }
    };

    return (
        <div className="detail-tab-container thin-scrollbar fade-on-load">
            <div
                className="participant-row-container"
                style={{ justifyContent: 'space-between', marginBottom: '16px' }}
            >
                <h3>
                    {dictionary.edit_experience}
                </h3>
            </div>
            <div style={{ marginLeft: -8, borderCollapse: "collapse" }}  className="provider-customer-booking-listing">
                <div className="form-layout group-dialog-content-container group-dialog-content-form-container" >
                    <div className="form-group">
                        <label htmlFor="status">Status:</label>
                        <select
                            id="status"
                            name="status"
                            value={formData?.status_id}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    status_id: parseInt(e.target.value, 10) // Ensure value is stored as an integer
                                }))
                            }
                            required
                            style={{ padding: "8px", fontSize: "14px" }} // Inline styles for better UI
                        >
                            {statusOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="title">Title:</label>
                        <input
                            type="text"
                            id="title"
                            name="title"
                            value={formData?.title}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="description">Description:</label>
                        <textarea
                            id="description"
                            name="description"
                            value={formData?.description}
                            onChange={handleInputChange}
                            rows="4"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="provided_items">Provided Items:</label>
                        <input
                            type="text"
                            id="provided_items"
                            name="provided_items"
                            value={formData?.provided_items}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="needed_items">Needed Items:</label>
                        <input
                            type="text"
                            id="needed_items"
                            name="needed_items"
                            value={formData?.needed_items}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="duration">
                            Duration: <span>
                                {ConverterHelper.secondsToDayHourMinute(
                                    formData?.duration,
                                    dictionary
                                )}
                            </span>
                        </label>
                        <input
                            type="text"
                            id="duration"
                            name="duration"
                            value={formData?.duration}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group" style={{ display: 'flex', flexDirection: 'row', gap: '10px' }} >
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.is_gttd)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, is_gttd: value ? "1" : "0"  }))}
                            type={1}
                            label={dictionary.is_gttd}
                        />
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.is_gttd_advertising)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, is_gttd_advertising: value ? "1" : "0"  }))}
                            type={1}
                            label={dictionary.gttd_advertizing}
                        />
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.check_matching_pois)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, check_matching_pois: value ? "1" : "0"  }))}
                            type={1}
                            label={dictionary.check_matching_pois}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="gttd">Google Thing To Do - OpenAi Parse:</label>
                        <ReactJson
                            id="gttd"
                            name="gttd"
                            src={formData?.gttd ? JSON.parse(formData?.gttd) : {}}
                            theme="monokai"
                            collapsed={true}
                            displayDataTypes={false}
                            enableClipboard={true}
                        />
                    </div>
                    <div className="form-group">
                        <label>Address Components</label>
                    </div>
                    <div className="form-group">
                        <label htmlFor="latitude">Latitude:</label>
                        <input
                            type="text"
                            id="latitude"
                            name="latitude"
                            value={formData?.latitude}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="longitude">Longitude:</label>
                        <input
                            type="text"
                            id="longitude"
                            name="longitude"
                            value={formData?.longitude}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="directions">Directions:</label>
                        <input
                            type="text"
                            id="directions"
                            name="directions"
                            value={formData?.directions}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="google_address">Google Address:</label>
                        <ReactJson
                            id="google_address"
                            name="google_address"
                            src={formData?.google_address ? JSON.parse(formData?.google_address) : {}}
                            theme="monokai"
                            collapsed={true}
                            displayDataTypes={false}
                            enableClipboard={true}
                        />
                    </div>
                    <div className="form-group" style={{ display: 'flex', flexDirection: 'row', gap: '10px' }} >
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.is_reselling)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, is_reselling: value ? "1" : "0"  }))}
                            type={1}
                            label={dictionary.is_reselling}
                        />
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.is_private_tour)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, is_private_tour: value ? "1" : "0" }))}
                            type={1}
                            label={dictionary.is_private_tour}
                        />
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.allow_requests)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, allow_requests: value ? "1" : "0"  }))}
                            type={1}
                            label={dictionary.allow_requests}
                        />
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.auto_confirm)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, auto_confirm: value ? "1" : "0"  }))}
                            type={1}
                            label={dictionary.auto_confirm}
                        />
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.is_free_event)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, is_free_event: value ? "1" : "0"  }))}
                            type={1}
                            label={dictionary.is_free_event}
                        />
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.is_eco_friendly)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, is_eco_friendly: value ? "1" : "0"  }))}
                            type={1}
                            label={dictionary.is_eco_friendly}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="cutoff_time">
                            Cutoff Time: <span>
                                {ConverterHelper.secondsToDayHourMinute(
                                    formData?.cutoff_time,
                                    dictionary
                                )}
                            </span>
                        </label>
                        <input
                            type="text"
                            id="cutoff_time"
                            name="cutoff_time"
                            value={formData?.cutoff_time}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="soft_cutoff_time">
                            Soft Cutoff Time: <span>
                                {ConverterHelper.secondsToDayHourMinute(
                                    formData?.soft_cutoff_time,
                                    dictionary
                                )}
                            </span>
                        </label>
                        <input
                            type="text"
                            id="soft_cutoff_time"
                            name="soft_cutoff_time"
                            value={formData?.soft_cutoff_time}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="minimum_age">Minimum Age:</label>
                        <input
                            type="text"
                            id="minimum_age"
                            name="minimum_age"
                            value={formData?.minimum_age}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="minimum_group_size">Minimum Group Size:</label>
                        <input
                            type="text"
                            id="minimum_group_size"
                            name="minimum_group_size"
                            value={formData?.minimum_group_size}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="maximum_group_size">Maximum Group Size:</label>
                        <input
                            type="text"
                            id="maximum_group_size"
                            name="maximum_group_size"
                            value={formData?.maximum_group_size}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.is_child_friendly)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, is_child_friendly: value ? "1" : "0"  }))}
                            type={1}
                            label={dictionary.is_child_friendly}
                        />
                        <label htmlFor="child_friendly_reason">Child Friendly Reason:</label>
                        <input
                            type="text"
                            id="child_friendly_reason"
                            name="child_friendly_reason"
                            value={formData?.child_friendly_reason}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.is_accessible)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, is_accessible: value ? "1" : "0"  }))}
                            type={1}
                            label={dictionary.is_accessible}
                        />
                        <label htmlFor="accessible_reason">Accessible Reason:</label>
                        <input
                            type="text"
                            id="accessible_reason"
                            name="accessible_reason"
                            value={formData?.accessible_reason}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <CustomCheckbox
                            checked={["1", 1, true].includes(formData?.has_upiria_cancellation_policy)} // Normalize to boolean
                            setChecked={(value) => setFormData((prev) => ({ ...prev, has_upiria_cancellation_policy: value ? "1" : "0"  }))}
                            type={1}
                            label={dictionary.has_upiria_cancellation_policy}
                        />
                        <label htmlFor="cancellation_policy_title">Cancellation Policy Title:</label>
                        <input
                            type="text"
                            id="cancellation_policy_title"
                            name="cancellation_policy_title"
                            value={formData?.cancellation_policy_title}
                            onChange={handleInputChange}
                            required
                        />
                        <label htmlFor="cancellation_policy_description">Cancellation Policy Description:</label>
                        <textarea
                            id="cancellation_policy_description"
                            name="cancellation_policy_description"
                            value={formData?.cancellation_policy_description}
                            onChange={handleInputChange}
                            rows="4"
                            required
                        />
                        <label htmlFor="cancellation_policy_data">Cancellation Policy Data:</label>
                        <ReactJson
                            id="cancellation_policy_data"
                            name="cancellation_policy_data"
                            src={formData?.cancellation_policy_data ? JSON.parse(formData?.cancellation_policy_data) : {}}
                            theme="monokai"
                            collapsed={true}
                            displayDataTypes={false}
                            enableClipboard={true}
                        />
                    </div>
                    <div className="form-group">
                        <button
                            type="submit"
                            className='button'
                            data-testid="group-dialog-finish-button"
                            onClick={handleSubmit}
                        >
                            {dictionary.save}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default connect(common.states, common.actions)(ProviderExperienceEditForm);